<div class="renderer__value">{{value()}}</div>
<app-copy-button [value]="value()"></app-copy-button>
